import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Mounted once inside each `<Canvas>`: it owns the canvas's tiled upload queue,
 * provides it to the consumers below, and advances it every frame at the pace the
 * GPU keeps up with (`gpuPacer.ts`).
 */
import { useMemo } from 'react';
import { useFrame, useThree } from '@react-three/fiber';
import { TiledUploadContext } from './TiledUploadContext';
import { TiledUploadQueue } from './TiledUploadQueue';
import { GpuPacer } from './gpuPacer';
import { webglFence } from './webglFence';
import { webglUploadRenderer } from './webglUploadRenderer';
import { useDisposeOnRelease } from '../useDisposeOnRelease';
/**
 * Upload time a frame may spend, half of a 60 Hz frame. The other half stays for
 * the render, so a frame with bands in it still makes its vsync.
 */
const FRAME_UPLOAD_BUDGET_MS = 8;
export function TiledUploadDriver({ children }) {
    const renderer = useThree((state) => state.gl);
    const pacer = useMemo(() => new GpuPacer(() => webglFence(renderer.getContext())), [renderer]);
    const queue = useMemo(() => new TiledUploadQueue(webglUploadRenderer(renderer), undefined, pacer), [renderer, pacer]);
    useDisposeOnRelease(pacer);
    useFrame(() => queue.tick(FRAME_UPLOAD_BUDGET_MS));
    return _jsx(TiledUploadContext.Provider, { value: queue, children: children });
}
//# sourceMappingURL=TiledUploadDriver.js.map